
<div class="drop-in-zone empty">
  <p><strong>Drag and Drop</strong> here</p>
</div>
